module.exports = __webpack_public_path__ + "static/assets/ce5857cb3273e67ba74583f863c45dd0.png";